import { Scoring } from '@/modules/score-set/types';
import { ScoreSetState } from '../state';
import { StudyState } from '@/common/types';

export const getScoreSet = (state: ScoreSetState) => state.scoreSet.data;

export const isSigned = (state: ScoreSetState) =>
  state.scoreSet.data?.status === Scoring.approved && !state.scoreSet.data?.isFailed;

export const isDraft = (state: ScoreSetState) =>
  state.scoreSet.data?.status !== Scoring.approved && !state.scoreSet.data?.isFailed;

export const isDownloadable = (state: ScoreSetState) => !state.scoreSet.data?.isFailed;

export const isReadOnly = (state: ScoreSetState) =>
  (state.scoreSet?.data?.studyState as StudyState) === StudyState.LOCKED;

export const isStudyStatePreparing = (state: ScoreSetState) =>
  state.scoreSet?.data?.studyState === StudyState.PREPARING;

export const is3PercentDesaturation = (state: ScoreSetState) =>
  state.scoreSet?.data?.desaturationRule === 3;
